// src/layout/menuItems.js
import { Home, History, MonitorCog, Upload, BookOpen, Merge } from "lucide-react";

export const getMenuItems = (navigate) => [
  {
    key: "home",
    icon: <Home className="w-5 h-5" />,
    label: "Dashboard",
    onClick: () => navigate("/dashboard"),
  },
  {
    key: "data-entry",
    icon: <Upload className="w-5 h-5" />,
    label: "Data Upload",
    onClick: () => navigate("/dashboard/data-entry"),
  },
  {
    key: "smart-merge",
    icon: <Merge className="w-5 h-5" />,
    label: "Smart Merge",
    onClick: () => navigate("/dashboard/smart-merge"),
  },
  {
    key: "anamoly-detection",
    icon: <MonitorCog className="w-5 h-5" />,
    label: "Anamoly detection",
   onClick: () => navigate("/dashboard/anamoly-detection"),
  },
  {
    key: "data-history",
    icon: <History className="w-5 h-5" />,
    label: "Data History",
    onClick: () => navigate("/dashboard/data-history"),
  },
  {
      key: "use-case",
      icon: <BookOpen className="w-4 h-4" />,
      label: "Use Cases",
      onClick: () => navigate("/dashboard/use-case"),
    },
];